/* eslint-disable camelcase */
/* istanbul ignore file */
// Initializing Smart Script arguments
const oneLinkURL = process.env.GATSBY_APPSFLYER_ONELINK_URL;
const mediaSource = { keys: ['source'], defaultValue: 'utm_source' };
const campaign = { keys: ['campaign'] };
const deepLinkValue = {
    keys: ['dp_dest'],
    defaultValue: 'application_entry'
};
const site_id = { paramKey: 'af_siteid', keys: ['site_id'] };
const custom_ss_ui = { paramKey: 'af_ss_ui', defaultValue: 'true' };
const deepLinkSub1 = {
    paramKey: 'deep_link_sub1',
    keys: ['campaign'],
    defaultValue: 'tmweb'
};
const deepLinkSub2 = {
    paramKey: 'deep_link_sub2',
    keys: ['source'],
    defaultValue: 'organic'
};
const deepLinkSub3 = {
    paramKey: 'deep_link_sub3',
    keys: ['campaign_product_type']
};
const deepLinkSub4 = {
    paramKey: 'deep_link_sub4',
    keys: ['click_id']
};
const deepLinkSub5 = {
    paramKey: 'deep_link_sub5',
    keys: ['gclid']
};

// Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
// Onelink URL is generated.
export const getOneLinkURL = (
    clickId = '',
    productTypeOverride = null
) => {
    const deepLinkSub3Override = productTypeOverride
        ? {
              paramKey: 'deep_link_sub3',
              defaultValue: productTypeOverride
          }
        : deepLinkSub3;

    return window?.AF_SMART_SCRIPT?.generateOneLinkURL({
        oneLinkURL,
        afParameters: {
            mediaSource,
            campaign,
            deepLinkValue,
            afCustom: [
                site_id,
                custom_ss_ui,
                deepLinkSub1,
                deepLinkSub2,
                deepLinkSub3Override,
                deepLinkSub4,
                deepLinkSub5
            ],
            afSub1: {
                paramKey: 'af_sub1',
                keys: ['click_id'],
                defaultValue: clickId
            },
            afSub2: {
                paramKey: 'af_sub2',
                keys: ['gclid']
            }
        }
    });
};

export const displayQRCode = (
    divId,
    clickId,
    productTypeOverride = null
) => {
    getOneLinkURL(clickId, productTypeOverride);
    window?.AF_SMART_SCRIPT?.displayQrCode(divId);
};
